<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.class.className')"
                                    v-model="searchData.className"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-select
                                    @change="pageChange"
                                    :items="roomItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.class.room')"
                                    hide-details
                                    solo
                                    v-model="searchData.classRoomId"
                                ></v-select>
                            </v-col>
<!--                            <v-col cols="12" md="3" sm="6" xs="3">-->
<!--                                <ETDatePicker v-model="searchData.openTime"-->
<!--                                              :label="$vuetify.lang.t('$vuetify.custom.class.openTime')"></ETDatePicker>-->
<!--                            </v-col>-->
<!--                            <v-col cols="12" md="3" sm="6" xs="3">-->
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.class.teacher')"-->
<!--                                    v-model="searchData.teacher"-->
<!--                                />-->
<!--                            </v-col>-->
                            <v-col cols="12" md="6" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn color="primary mr-3" v-5="permissionCode.search" @click="pageChange" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                    <v-btn color="success mr-3" v-5="permissionCode.import" dark large @click="importClassAndStu">
                                        <v-icon left>mdi-file-import</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.class.import') }}
                                    </v-btn>
                                    <v-btn color="success mr-3" v-5="permissionCode.async" dark large @click="changeClasses">
                                        <v-icon left>mdi-car-turbocharger</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.class.changeClasses') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="name"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.seatSettingStatus="{ item }">
                            <div :style="colorItem(item.seatSettingStatus)">
                            {{ item.seatSettingStatus == 0?"已排座":item.seatSettingStatus == 1?"尚未排完":"有转班未排座学生" }}
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="normal" x-small class="ml-2"
                            @click="updateSeats(item)" v-5="permissionCode.row">
                                <v-icon small>
                                    mdi-human-male
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.class.rowSeats') }}
                            </v-btn>
                            <v-btn color="normal" x-small @click="updateItem(item)" class="ml-2" v-5="permissionCode.update">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.class.update') }}
                            </v-btn>
                            <v-btn color="normal" x-small @click="updateStuItem(item)" class="ml-2" v-5="permissionCode.updatePerson">
                                <v-icon small>
                                    mdi-account-edit-outline
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.class.updateList') }}
                            </v-btn>
                            <v-btn color="normal" x-small v-if="!item.isGraduate && item.classType == 1" @click="clickChangeClassroom(item)" class="ml-2" v-5="permissionCode.change">
                                <v-icon small>
                                    mdi-recycle-variant
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.class.changeClassroom') }}
                            </v-btn>
                            <v-btn :color="!item.isGraduate?'error':'success'" x-small @click="clickGraduation(item)" class="ml-2" v-5="permissionCode.graduate">
                                <v-icon small>
                                    mdi-school
                                </v-icon>
                                {{ !item.isGraduate?$vuetify.lang.t('$vuetify.custom.class.graduation'):$vuetify.lang.t('$vuetify.custom.class.graduated') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
            <v-dialog v-model="changeClassroom.showDetail" max-width="500px">
                <v-card>
                    <v-card-title class="d-flex flex-row-reverse">
                        <v-btn x-small fab @click="changeClassroom.showDetail=false">
                            <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="9">
                                    <v-select
                                        :items="roomItems"
                                        :label="$vuetify.lang.t('$vuetify.custom.class.room')"
                                        hide-details
                                        solo
                                        v-model="changeClassroom.roomId"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="3" style="text-align: center;">
                                    <v-btn color="primary" @click="classroomChange" large>确认更换</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="updateClassDialog" persistent max-width="700px">
                <class-update v-model="updateClassDialog" @initialize="pageChange" :classMsg="classMsg"></class-update>
            </v-dialog>
            <v-dialog v-model="updateClassStuDialog" max-width="1300px">
                <class-stu-update v-model="updateClassStuDialog" :classStuMsg="classStuMsg"></class-stu-update>
            </v-dialog>
            <v-dialog
                v-model="importDialog"
                max-width="500px"
                persistent
            >
                <v-card>
                    <v-card-title>
                        选择导入班级
                    </v-card-title>
                    <v-card-text>
                        <v-select
                            v-model="selectValue"
                            :items="select"
                            label="选择班级"
                            hide-details
                        ></v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error" dark
                            @click="importDialog = false"
                        >
                            取消
                        </v-btn>
                        <v-btn
                            color="success" dark @click="importClass"
                        >
                            导入
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>
<style></style>
<script>
    import Mock from 'mockjs';
    import ETDatePicker from '@/components/datepicker/ETDatePicker'
    import classUpdate from './class-update'
    import classStuUpdate from './class-stu-update'
    import longTimeOut from "@/api/longTimeOut";

    export default {
        data() {
            return {
                permissionCode:{
                    search:'biz:class:search',
                    row:'biz:class:row',
                    update:'biz:class:update',
                    updatePerson:'biz:class:update:person',
                    import:'biz:class:import:ding',
                    async:'biz:class:async:ding',
                    change:'biz:class:change',
                    graduate:'biz:class:graduate',
                },
                importDialog: false,
                classStuMsg: {},
                classMsg: {},
                updateClassStuDialog: false,
                updateClassDialog: false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    className: '',
                    room: '',
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.class.className'), value: 'className',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.class.room'), value: 'classRoomName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.class.ifRowSeats'), value: 'seatSettingStatus',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.class.openTime'), value: 'classStart',
                    },
                    // {
                    //     text: this.$vuetify.lang.t('$vuetify.custom.class.teacher'), value: 'teacher',
                    // },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
                roomItems: [
                    {text: "选择教室", value: ''},
                ],
                select: [],
                selectValue: '',
                changeClassroom: {
                    showDetail:false,
                    roomId: '',
                    classId: '',
                    oldRoomId:'',
                },
                overlay:false,
            }

        },
        mounted() {
            this.initSelect();
        },
        methods: {
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            colorItem(num) {
                if(num != 0){
                    return "color:red"
                }else {
                    return "color:green"
                }
            },
            importClass() {
                if (this.selectValue == "") {
                    this.$dialog.alert("请选择班级")
                    return
                }
                this.$api.importDingTalk.importClassAndStu(this.selectValue).then(data => {
                    if (data.flag) {
                        this.importDialog = !this.importDialog
                        this.$dialog.alert("导入成功")
                        this.initialize()
                        //刷新列表
                    }
                })
            },
            importClassAndStu() {
                if (this.select.length == 0) {
                    this.$dialog.alert("没有可导入的数据")
                    return
                }
                this.importDialog = !this.importDialog
            },
            initSelect() {
                var _this = this
                this.$api.importDingTalk.getSelectList().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            _this.select.push({text: obj.name, value: obj.dingTalkDepartmentId})
                        })
                    }
                })

                this.$api.bizClassRoom.selectAllClassRoom().then((data)=>{
                    if(data.data){
                        data.data.forEach(val=>{
                            this.roomItems.push({text:val.roomName,value:val.roomId})
                        })
                    }
                })
            },
            updateStuItem(item) {
                this.updateClassStuDialog = true
                this.classStuMsg = item
            },
            updateItem(item) {
                this.updateClassDialog = true
                this.classMsg = item
            },
            updateSeats(item) {
                this.$router.push({
                    name: "RowOfSeats",
                    params: {
                        classId:item.id
                    }
                })
            },
            initialize() {
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.classList.getClassList(
                    Object.assign({}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
                // this.loading = false;
                // let data = Mock.mock({
                //     'data|10': [
                //         {
                //             'className': '班级1',
                //             "room": "教室1",
                //             "openTime": Mock.mock('@now'),
                //             "teacher": '@cname',
                //         }
                //     ]
                // });
                // this.desserts = data.data
                // this.totalDesserts = 10;

            },
            changeOptions(option) {
                this.initialize()
            },
            clickChangeClassroom(item){
                this.changeClassroom.showDetail = true;
                this.changeClassroom.classId = item.id;
                this.changeClassroom.oldRoomId = item.classRoomId;
            },
            classroomChange(){
                if(!this.changeClassroom.classId || !this.changeClassroom.roomId){
                    this.$dialog.alert("请选择教室");
                    return;
                }
                if(this.changeClassroom.oldRoomId == this.changeClassroom.roomId){
                    this.$dialog.alert("不能选择当前所在教室");
                    return;
                }
                this.$api.classList.changeClassroom({
                    outClassId:this.changeClassroom.classId,
                    inRoomeId:this.changeClassroom.roomId
                }).then(data=>{
                    if(data.flag){
                        this.initialize()
                        this.changeClassroom.showDetail = false;
                    }
                })
            },
            clickGraduation(item){
                if(item.isGraduate){
                    this.$dialog.alert("已毕业无需操作");
                    return;
                }
                this.$dialog.confirm("确定对当前班级进行毕业操作吗?当前操作不可逆!",'提示',()=>{
                    this.$api.classList.graduate(item.id).then(data=>{
                        if(data.flag){
                            this.$dialog.alert("成功毕业");
                            this.initialize()
                        }
                    })
                });
            },
            changeClasses(){
                this.$dialog.confirm("确定同步当前转班学生吗?请勿频繁操作!",'提示',()=>{
                    this.overlay = true;
                    longTimeOut.dingtalk_student_sync().then(data=>{
                        this.overlay = false;
                        if(data.flag){
                            this.$dialog.alert("同步成功");
                            this.initialize()
                        }
                    }).catch(()=>{
                        this.overlay = false;
                    })
                });
            },
        },
        components: {
            ETDatePicker, classUpdate, classStuUpdate
        },
    }
</script>
